import { render, staticRenderFns } from "./ChangePriceBlock.vue?vue&type=template&id=6fd62da1&scoped=true&"
import script from "./ChangePriceBlock.vue?vue&type=script&lang=ts&"
export * from "./ChangePriceBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePriceBlock.vue?vue&type=style&index=0&id=6fd62da1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd62da1",
  null
  
)

export default component.exports